import { render, staticRenderFns } from "./viewExtrinsicFactorsNode.vue?vue&type=template&id=a6e96a9e&scoped=true&"
import script from "./viewExtrinsicFactorsNode.vue?vue&type=script&lang=js&"
export * from "./viewExtrinsicFactorsNode.vue?vue&type=script&lang=js&"
import style0 from "./viewExtrinsicFactorsNode.vue?vue&type=style&index=0&id=a6e96a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e96a9e",
  null
  
)

export default component.exports